import { ApiComponentType, ApiExtraService } from '@ibe/api';
import React, { JSX } from 'react';
import { ComponentBoxProps } from '../../../Models/ItemRegistry';
import PackageBox from '../../Components/PackageBox/PackageBox';
import PackageBoxServiceInfoLayout from '../../Components/PackageBox/PackageBoxServiceInfoLayout';
import default404Image from '../../Components/UI/Images/Default404Image';
import { Slider, withMedia } from '../../Components/UI/Slider/Slider';
import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/extraPackageBox.en.t.json';
import Keys from '../../../_Translations/generated/extraPackageBox.en.t.json.keys';

const PackageComponentBox = (props: ComponentBoxProps): JSX.Element => {
  const { component, onModifyComponent, onRemoveComponent } = props;
  const service = component.selectedItems[0] as ApiExtraService;
  const { t } = useTranslation('extraPackageBox', fallback, Keys);
  const itemType = component.subItemType ? component.subItemType : component.itemType;
  const selectedExtra = component.selectableItems.find(
    item => item.id === component.selectedItems[0].id
  ) as ApiExtraService;
  const showButton =
    selectedExtra.serviceOptions.length > 1 ||
    (selectedExtra.extraUnits && selectedExtra.extraUnits.length > 1) ||
    (selectedExtra.extraUnits &&
      selectedExtra.extraUnits[0].unitRates &&
      selectedExtra.extraUnits[0].unitRates.length > 1);

  const handleShowServices = (): void => {
    if (onModifyComponent) {
      onModifyComponent(component.id);
    }
  };

  const handleShowServiceDetail = (): void => {
    if (onModifyComponent) {
      onModifyComponent(component.id, { isUnitSelected: true });
    }
  };

  return (
    <PackageBox
      header={withMedia(Slider, default404Image, service.media, {
        mobileControls: true
      })}
      onRemoveComponent={(): void =>
        onRemoveComponent && onRemoveComponent(component.id, service.id)
      }
      content={
        <PackageBoxServiceInfoLayout
          headline={service.name}
          unitDescription={service.serviceType.description}
          startDate={service.start ? service.start : ''}
          endDate={service.end ? service.end : ''}
          changeUnitLabel={t(Keys.CHANGE_OPTION)}
          changeServiceLabel={t(`subItemType_${itemType}`)}
          onShowServices={component.selectableItems.length > 1 ? handleShowServices : undefined}
          onShowServiceOptions={showButton ? handleShowServiceDetail : undefined}
        />
      }
      isIncluded={component.componentType !== ApiComponentType.OPTIONAL}
    />
  );
};

export default PackageComponentBox;
